export default {
  async updateFile(file, containerName, prefixName = '') {
    const containerURL = new window.azblob.ContainerURL(
        `${process.env.VUE_APP_CDN_BLOBURI}/${containerName}${process.env.VUE_APP_CDN_SASTOKEN}`,
        window.azblob.StorageURL.newPipeline(new window.azblob.AnonymousCredential));

    const generateUuid = function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    try {
      const nameFile = `${prefixName}--${generateUuid(file.name.split(".")[0])}.${file.name.split('.')[1]}`
      const blockBlobURL = window.azblob.BlockBlobURL.fromContainerURL(containerURL, nameFile);
      await window.azblob.uploadBrowserDataToBlockBlob(window.azblob.Aborter.none, file, blockBlobURL);
      return nameFile
    } catch (error) {
      console.log(error)
      console.log(error.body.message);
    }
  }
}